<template>
  <main class="content content--narrow">
    <section class="content--boxed">Logging in...</section>
  </main>
</template>

<script>
import { errHandler } from '@/helpers'

export default {
  data () {
    return {}
  },
  created () {
    this.loginas()
  },
  computed: {
    stickyMsg () {
      return typeof this.$route.query.sticky !== 'undefined' ? this.$t(`messages.${this.$route.query.sticky}`) : ''
    }
  },
  methods: {
    async loginas () {
      try {
        await this.$store.dispatch('auth/loginas', { authenticate: this.$route.params.authenticate })
        this.$router.push({ name: 'root' })
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      } finally {
      }
    }
  }
}
</script>
